import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from "@angular/core";

@Component({
  selector: "up-env-badge",
  templateUrl: "./env-badge.component.html",
  styleUrl: "./env-badge.component.css",
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EnvBadgeComponent implements OnInit {
  @Input() env?: "staging" | "development" | "production";

  style: string = "";

  ngOnInit(): void {
    const envStyles = {
      development:
        "background-color: firebrick; color: white; font-size: 0.5rem; padding: 1px 24px; border-radius: 4px;",
      staging:
        "background-color: goldenrod; color: black; font-size: 0.5rem; padding: 1px 24px; border-radius: 4px;",
      production: "",
    };

    this.style = !this.env ? "" : envStyles[this.env];
  }
}
